import { ReactNode } from 'react';
import cl from 'classnames';

import { ComposerAspectRatioValue } from '../../composerTypes';

interface ComposerAspectRatioFrameProps {
  aspectRatio: ComposerAspectRatioValue;
  cssValue: string | undefined;
  children: ReactNode;
}

// Same letterbox trick as ModelViewerAspectRatioFrame: a CSS aspect-ratio box
// physically shrinks the mount point, and the composer widget's R3F <Canvas>
// (which fills its container at 100%/100%) resizes with it — no need to
// reach into the widget's camera/canvas directly.
function ComposerAspectRatioFrame({
  aspectRatio,
  cssValue,
  children
}: ComposerAspectRatioFrameProps) {
  const isAuto = aspectRatio === ComposerAspectRatioValue.AUTO;

  return (
    <div className={cl('absolute', isAuto ? 'inset-0' : 'inset-4')}>
      <div
        className="absolute inset-0 m-auto max-w-full max-h-full"
        style={isAuto ? undefined : { aspectRatio: cssValue }}
      >
        {!isAuto && (
          <div
            className="z-1 absolute inset-0 pointer-events-none"
            style={{ filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.2))' }}
          >
            <div className="absolute inset-0">
              <div className="border-t-2 border-l-2 border-white/50 w-8 h-8 absolute top-0 left-0" />
              <div className="border-t-2 border-r-2 border-white/50 w-8 h-8 absolute top-0 right-0" />
              <div className="border-b-2 border-l-2 border-white/50 w-8 h-8 absolute bottom-0 left-0" />
              <div className="border-b-2 border-r-2 border-white/50 w-8 h-8 absolute bottom-0 right-0" />
            </div>
          </div>
        )}
        <div className="absolute inset-0">{children}</div>
      </div>
    </div>
  );
}

export default ComposerAspectRatioFrame;
